import { render } from "./DetailExperienceElements.vue?vue&type=template&id=9dd4455a&scoped=true"
import script from "./DetailExperienceElements.vue?vue&type=script&lang=js"
export * from "./DetailExperienceElements.vue?vue&type=script&lang=js"

import "./DetailExperienceElements.vue?vue&type=style&index=0&id=9dd4455a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9dd4455a"

export default script